var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"site-reveal"}},[(!_vm.siteIsReady)?_c('div',{staticClass:"site-reveal"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }